import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AssignmentIndIcon(props: IconProps) {
    return <Icon {...props} iconKey={"assignment_ind"}/>
}
